import React, { useEffect, useId, useMemo, useState } from "react";
import { useIsGuest } from "../../login/AuthContext";

export function usePrivacyOn(){
    return useMemo(() => {
        return isPrivacyOn();
    }, [])
}

export function isPrivacyOn(): boolean {
    return localStorage.getItem("privacyOn") != null;
}

function setPrivacyOn(on:boolean){
    if(!on){
        localStorage.removeItem("privacyOn")
    } else {
        localStorage.setItem("privacyOn", "true")
    }
    location.reload();
}


export function PrivacyToggle(){
    const isPrivatcyOn = usePrivacyOn()
    const [on, setOn] = useState(isPrivatcyOn);
    const guest = useIsGuest();

    const id = useId();
    if(guest) return null

    return <div className="form-check my-3 column-input">
        <input className="form-check-input" type="checkbox" checked={on} onChange={() => {setOn(!on); setPrivacyOn(!isPrivatcyOn)}} id={id} />
        <label className="form-check-label" htmlFor={id}>
            Ocultar nomes de franquias
        </label>
    </div>
}
